import React from 'react';
import { Column } from 'rbx';
import { FieldArray } from 'formik';
import { toast } from 'react-toastify';
import ImageView from './ImageView';
import { getEncodedImage } from '../../../utils/s3';

const Images = ({ reviewStatus, images, setFieldValue }) => (
  <Column.Group vcentered multiline gapSize={8}>
    <FieldArray
      name="images"
      render={() => (
        <>
          {images.map((item, index) => (
            <Column size={3} key={item.image_id}>
              <ImageView
                reviewStatus={reviewStatus}
                imageReviewId={item.image_id}
                imageSrc={getEncodedImage(item.url, 300, 300)}
                status={item.status}
                approvalStatus={item.approval_status}
                handleApprovalStatus={value => {
                  if (images.length === 1) {
                    toast.error('Default Image cannot be rejected', {
                      autoClose: 3000,
                      closeOnClick: true,
                    });
                  } else {
                    setFieldValue(`images.${index}.approval_status`, value);
                  }
                }}
              />
            </Column>
          ))}
        </>
      )}
    />
  </Column.Group>
);

export default Images;
